// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__3iKFb"};